"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMockFactory = void 0;
class BaseMockFactory {
    /**
     * Does nothing by default.
     * Can be used to transform JSON to a class
     * e.g. ExampleModel.fromJSON(json)
     * @param json
     * @returns
     */
    transform(json) {
        return json;
    }
    /**
     * Generates a mock of the desired form
     * @param overrides data to override that given by the defaults
     * @returns
     */
    mock(overrides) {
        const defaultData = this.defaultData();
        return Object.assign({}, defaultData, overrides);
    }
    /**
     * Hooks into the chosen transformation function and provides a transformed version of the mock data
     * e.g. converts JSON to a class
     * @param overrides
     * @returns
     */
    mockTransformed(overrides) {
        const mockJSON = this.mock(overrides);
        return this.transform(mockJSON);
    }
    /**
     * Generates the desired number of mocked objects
     * @param count
     * @param overrideFunctions must be functions that return mock data overriding attributes on the mock object
     * @returns
     */
    listMocks(count, overrideFunctions) {
        const mocks = [];
        for (let index = 0; index < count; index++) {
            const overrides = this.applyOverrideFunctions(overrideFunctions);
            mocks.push(this.mock(overrides));
        }
        return mocks;
    }
    listTransformed(count, overrideFunctions) {
        const mocks = this.listMocks(count, overrideFunctions);
        return mocks.map(this.transform);
    }
    /**
     * Must receive functions which, when called, generate the desired type
     * @param overrideFunctions
     * @returns
     */
    applyOverrideFunctions(overrideFunctions) {
        // made this any so it compiles
        const overrideValues = {};
        for (const key in overrideFunctions) {
            const fun = overrideFunctions[key];
            overrideValues[key] = fun();
        }
        return overrideValues;
    }
}
exports.BaseMockFactory = BaseMockFactory;
